/**
 * Chuẩn hóa URL ảnh sản phẩm ở tầng đọc.
 *
 * Ảnh import từ nguồn ngoài (Shopify) trả về dạng protocol-relative
 * ("//product.hstatic.net/..."). Resolver hiện đã thêm "https:" trước khi lưu,
 * nhưng các sản phẩm import trước đó vẫn còn URL sai trong DB nên phải xử lý
 * lại khi đọc. URL không dùng được sẽ trả về ảnh placeholder để next/image
 * không throw và sản phẩm không bị hiện ra trống ảnh.
 */

export const PRODUCT_IMAGE_FALLBACK = '/assets/images/no_image.png';

/** Trả về URL dùng được, hoặc '' nếu không thể chuẩn hóa. */
export function normalizeProductImageUrl(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  // Ảnh nội bộ (/assets/..., /uploads/...) dùng nguyên trạng.
  if (raw.startsWith('/') && !raw.startsWith('//')) return raw;

  const withProtocol = raw.startsWith('//')
    ? `https:${raw}`
    : raw.startsWith('http://')
      ? `https://${raw.slice('http://'.length)}`
      : raw;

  if (!/^https:\/\//i.test(withProtocol)) return '';

  try {
    // Chặn URL rác không parse được (next/image sẽ throw nếu để đi tiếp).
    new URL(withProtocol);
  } catch {
    return '';
  }
  return withProtocol;
}

/** Như trên nhưng luôn trả về một URL hiển thị được. */
export function productImageOrFallback(value: unknown): string {
  return normalizeProductImageUrl(value) || PRODUCT_IMAGE_FALLBACK;
}

/** Chuẩn hóa danh sách ảnh, bỏ URL lỗi và trùng lặp. */
export function normalizeProductImageList(values: unknown): string[] {
  if (!Array.isArray(values)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const value of values) {
    const url = normalizeProductImageUrl(value);
    if (!url || seen.has(url)) continue;
    seen.add(url);
    out.push(url);
  }
  return out;
}
